import { Grid } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { CircularProgress, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { BsFiletypeCsv } from "react-icons/bs";
import { Item } from "semantic-ui-react";

import Modal from "../../../../../../../../components/Generic/Modal";

const styles = makeStyles(() => ({
  downloadButtonMargin0: {
    margin: 0,
  },
}));

export default styles;

export const StorageBoxImportModal = styled(Modal)(() => ({
  width: "55vw !important",
}));

export const Dropzone = styled("div")(() => ({
  cursor: "pointer",
}));

export const DropzoneButton = styled(Stack)(() => ({
  border: "1px dashed #CCDEEE",
  borderRadius: "8px",
  padding: "25px 16px",
}));

export const TextButton = styled(Item)(() => ({
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize: "16px",
  lineHeight: "24px",
  color: "#308CDB",
}));

export const TextButtonInfo = styled(Item)(() => ({
  fontFamily: "Manrope",
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "21px",
  color: "#667085",
}));

export const TextButtonFormat = styled("span")(() => ({
  fontFamily: "Manrope",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "24px",
  color: "#667085",
}));

export const ErrorTitle = styled(Grid)(() => ({
  color: "#232325",
  fontFamily: "Inter",
  fontSize: "15px",
  fontWeight: 400,
  lineHeight: "24px",
}));

export const ErrorLine = styled(Grid)(() => ({
  color: "#F79009",
  fontFamily: "Inter",
  fontStyle: "italic",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "24px",
}));

export const ShowFile = styled("div")(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  background: "#FCFCFD",
  borderRadius: "12px",
  paddingLeft: "16px",
}));

export const ShowFileLeft = styled("div")(() => ({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
}));

export const CSVIcon = styled(BsFiletypeCsv)(() => ({
  color: "#F97066",
}));

export const FileName = styled("span")(() => ({
  fontFamily: "Manrope",
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "24px",
  color: "#667085",
  marginLeft: "12px",
}));

export const CloseIcon = styled(AiOutlineCloseCircle)(() => ({
  color: "#F97066",
}));

export const LoadingMainDiv = styled("div")(() => ({
  width: "100%",
  display: "flex !important",
  justifyContent: "center !important",
  alignItems: "center !important",
}));

export const LoadingContainer = styled("div")(() => ({
  display: "flex",
  width: "80%",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  gap: "40px",
  alignSelf: "center",
}));

export const LoadingTitle = styled("span")(() => ({
  fontFamily: "Manrope",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: "20px",
  color: "#308CDB",
  textAlign: "center",
}));

export const LoadingProgress = styled(CircularProgress)(() => ({
  width: "25% !important",
  height: "100% !important",
  color: "#308CDB",
}));
